import { render, staticRenderFns } from "./coordinates-viewer.vue?vue&type=template&id=80f254a8&scoped=true"
import script from "./coordinates-viewer.vue?vue&type=script&lang=js"
export * from "./coordinates-viewer.vue?vue&type=script&lang=js"
import style0 from "./coordinates-viewer.vue?vue&type=style&index=0&id=80f254a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f254a8",
  null
  
)

export default component.exports